export default "__VITE_ASSET__ddecc02b__"